<mat-card class="mb-4 rounded-3xl border border-slate-200 p-4 shadow-lg shadow-slate-200/60">
  <div class="mb-3 flex items-center justify-between gap-3">
    <h3 class="text-lg font-semibold text-slate-900">Presenting problem</h3>
    @if (canEdit() && !editing()) {
      <button mat-stroked-button type="button" (click)="edit()">{{ isEmpty() ? 'Record problem' : 'Edit' }}</button>
    }
  </div>

  @if (editing()) {
    <form [formGroup]="form" (submit)="$event.preventDefault(); save()" class="grid gap-4">
      <p class="text-sm text-slate-500">Choose the cluster the problem belongs to, and then the problem within it. The secondary problem is optional.</p>
      <div class="grid gap-x-4 md:grid-cols-2">
        <lookup-select formControlName="primaryClusterId" label="Primary problem cluster" [options]="clusters()" (selectionChanged)="clusterChanged('primary')" />
        <lookup-select
          formControlName="primaryProblemId"
          label="Primary problem"
          [options]="problemsOf(form.controls.primaryClusterId.value)"
          [hint]="form.controls.primaryClusterId.value ? null : 'Choose the cluster first.'" />
        <lookup-select formControlName="secondaryClusterId" label="Secondary problem cluster (optional)" [options]="clusters()" (selectionChanged)="clusterChanged('secondary')" />
        <lookup-select
          formControlName="secondaryProblemId"
          label="Secondary problem (optional)"
          [options]="problemsOf(form.controls.secondaryClusterId.value)"
          [hint]="form.controls.secondaryClusterId.value ? null : 'Choose the cluster first.'" />
      </div>
      <div class="flex justify-end gap-2">
        <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
        <button mat-flat-button type="submit" [disabled]="store.savingPresentingProblem()">
          @if (store.savingPresentingProblem()) {
            <mat-spinner diameter="20" class="mr-2" />
          }
          Save problem
        </button>
      </div>
    </form>
  } @else if (isEmpty()) {
    <p class="text-sm text-slate-500">No presenting problem has been recorded.</p>
  } @else {
    @if (store.presentingProblem(); as coding) {
      <dl class="grid gap-x-6 gap-y-2 text-sm md:grid-cols-2">
        <div class="flex gap-2">
          <dt class="w-36 shrink-0 text-slate-500">Primary cluster</dt>
          <dd class="font-medium text-slate-900">{{ coding.primary.cluster }}</dd>
        </div>
        <div class="flex gap-2">
          <dt class="w-36 shrink-0 text-slate-500">Primary problem</dt>
          <dd class="font-medium text-slate-900">{{ coding.primary.problem }}</dd>
        </div>
        @if (coding.secondary.problemId) {
          <div class="flex gap-2">
            <dt class="w-36 shrink-0 text-slate-500">Secondary cluster</dt>
            <dd class="font-medium text-slate-900">{{ coding.secondary.cluster }}</dd>
          </div>
          <div class="flex gap-2">
            <dt class="w-36 shrink-0 text-slate-500">Secondary problem</dt>
            <dd class="font-medium text-slate-900">{{ coding.secondary.problem }}</dd>
          </div>
        }
      </dl>
    }
  }
</mat-card>
